export const internal = { UserLocation: 'internal' }
export const external = { UserLocation: 'external' }
